import { KnowledgeBase } from '../KnowledgeBaseSection/KnowledgeBase'
import { AutoFollowUpSection } from '../AutoFollowUpSection/AutoFollowUpSection'
import { TriggerSection } from '../TriggerSection/TriggerSection'
import styles from './styles.module.scss'
import { InstructionsSection } from '../InstructionsSection/InstructionsSection'
import { BookingSection } from '../BookingSection/BookingSection'

export const Configure = () => {
  return (
    <>
      <div className={styles.section}>
        <TriggerSection />
      </div>
      <div className={styles.section}>
        <InstructionsSection />
      </div>
      <div className={styles.section}>
        <KnowledgeBase />
      </div>
      <div className={styles.section}>
        <BookingSection />
      </div>
      <div className={styles.section}>
        <AutoFollowUpSection />
      </div>
    </>
  )
}
